import React from "react";
import Link from "next/link";
import { TextScramble } from "../ui/text-scramble";
import { useNavContext } from "./NavContext";

interface NavLinkProps {
  href: string;
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
}

export const NavLink: React.FC<NavLinkProps> = React.memo(
  ({ href, children, ariaLabel, className = "" }) => {
    const { isActive, closeMenu } = useNavContext();

    // Check if the link is external (doesn't start with "/")
    const isExternalLink = !href.startsWith("/");

    return (
      <Link
        href={href}
        aria-label={ariaLabel || String(children)}
        className={`text-xs uppercase ${
          isActive(href) ? "text-[#FF0000] underline" : ""
        } ${className}`}
        onClick={closeMenu}
        target={isExternalLink ? "_blank" : undefined}
        rel={isExternalLink ? "noopener noreferrer" : undefined}
      >
        <TextScramble characterSet=". ">{String(children)}</TextScramble>
      </Link>
    );
  }
);

NavLink.displayName = "NavLink";
